import { FetchRequestState } from 'types'

export enum Actions {
  UPSERT_ARTICLE_INFORMAL_FEEDBACK_REQUESTS_FETCH_REQUEST = 'UPSERT_ARTICLE_INFORMAL_FEEDBACK_REQUESTS_FETCH_REQUEST',
}

export function upsertFetchRequest(articleKey: string, state: FetchRequestState) {
  return {
    type: Actions.UPSERT_ARTICLE_INFORMAL_FEEDBACK_REQUESTS_FETCH_REQUEST,
    payload: { articleKey, state },
  }
}
